import { MainLayout } from "../layouts";
import { SocialKajian } from "../components";

import { VisiMisiSection } from "../components/VisiMisiCard";
import { LiputanSection } from "../layouts/HomePage";

const VisiMisi = () => {
  return (
    <MainLayout title={"Visi Misi - Dikmen Idrisiyyah"}>
      <div className="flex flex-col lg:flex-row lg:justify-between gap-8 mb-10">
        <VisiMisiSection />
        <SocialKajian />
      </div>
      <LiputanSection />
    </MainLayout>
  );
};

export default VisiMisi;
